import React from 'react';
import { Grid } from '@mui/material';
import { dropBoolean, dropTipoMascara } from 'utils/drops';
import Input from 'components/Input';
import Dropdown from 'components/Dropdown';

const Filter = ({ grid, control }) => {
  const checkDisplay = (name) => {
    const column = grid?.colunas?.find((c) => c?.field === name);
    if (column?.filterable) {
      return true;
    }
    return false;
  };

  return (
    <Grid container spacing={2}>
      {checkDisplay('id') && (
        <Grid item xs={12}>
          <Input name="id" control={control} label="ID" type="number" />
        </Grid>
      )}
      {checkDisplay('descricao') && (
        <Grid item xs={12}>
          <Input name="descricao" control={control} label="Descrição" />
        </Grid>
      )}
      {checkDisplay('tipo_mascara') && (
        <Grid item xs={12}>
          <Dropdown
            multiple
            name="tipo_mascara"
            control={control}
            label="Tipo de Máscara"
            options={dropTipoMascara}
          />
        </Grid>
      )}
      {checkDisplay('envionf') && (
        <Grid item xs={12}>
          <Dropdown
            name="envionf"
            control={control}
            label="Envio NF"
            options={dropBoolean}
          />
        </Grid>
      )}
      {checkDisplay('enviobol') && (
        <Grid item xs={12}>
          <Dropdown
            name="enviobol"
            control={control}
            label="Envio Boleto"
            options={dropBoolean}
          />
        </Grid>
      )}
      {checkDisplay('ativo') && (
        <Grid item xs={12}>
          <Dropdown
            name="ativo"
            control={control}
            label="Ativo"
            options={dropBoolean}
          />
        </Grid>
      )}
    </Grid>
  );
};

export default Filter;
